import { Component, forwardRef, input, OnInit } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { WNL_HOST_CONTROL, WnlHostControl, WnlHostType } from 'src/app/shared/tokens/wnl-host-control.token';

/**
 * A wrapper for the p-checkbox component. Displays a checkbox with a label
 * next to it.
 *
 * To see examples where this component is used, visit any of the classes that extend the
 * AssessmentFormComponent class (e.g. Cardiovascular, Gastrointestinal, Genitourinary).
 */
@Component({
  selector: 'emr-checkbox',
  templateUrl: './emr-checkbox.component.html',
  styleUrls: ['./emr-checkbox.component.scss'],
  standalone: true,
  providers: [
    {
      provide: WNL_HOST_CONTROL,
      useExisting: forwardRef(() => EmrCheckboxComponent),
    },
  ],
  imports: [
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class EmrCheckboxComponent implements OnInit, WnlHostControl {
  /**
   * The text to display next to the checkbox.
   */
  label = input.required<string>();

  uniqueId = '';

  /**
   * The FormControl to get/set the value for.
   */
  control = input.required<UntypedFormControl>();

  ngOnInit() {
    this.uniqueId = this.label() + Math.random();
  }

  getWnlControl(): UntypedFormControl | null {
    return this.control();
  }

  getWnlHostType(): WnlHostType {
    return 'checkbox';
  }
}
